/**
 * @fileoverview gRPC-Web generated client stub for io.codedrills.proto.user
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var io_codedrills_proto_content_view_pb = require('../../../../io/codedrills/proto/content/view_pb.js')

var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js')

var io_codedrills_proto_user_team_pb = require('../../../../io/codedrills/proto/user/team_pb.js')

var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js')

var io_codedrills_proto_content_pagination_pb = require('../../../../io/codedrills/proto/content/pagination_pb.js')
const proto = {};
proto.io = {};
proto.io.codedrills = {};
proto.io.codedrills.proto = {};
proto.io.codedrills.proto.user = require('./team_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.TeamServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.CreateTeamsBatchRequest,
 *   !proto.io.codedrills.proto.user.CreateTeamsBatchResponse>}
 */
const methodInfo_TeamService_CreateTeamsBatch = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.CreateTeamsBatchResponse,
  /** @param {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.CreateTeamsBatchResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.CreateTeamsBatchResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.CreateTeamsBatchResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.createTeamsBatch =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/CreateTeamsBatch',
      request,
      metadata || {},
      methodInfo_TeamService_CreateTeamsBatch,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.CreateTeamsBatchResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.createTeamsBatch =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/CreateTeamsBatch',
      request,
      metadata || {},
      methodInfo_TeamService_CreateTeamsBatch);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetTeamRequest,
 *   !proto.io.codedrills.proto.user.GetTeamResponse>}
 */
const methodInfo_TeamService_GetTeam = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetTeamResponse,
  /** @param {!proto.io.codedrills.proto.user.GetTeamRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetTeamResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetTeamResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetTeamResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.getTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetTeam',
      request,
      metadata || {},
      methodInfo_TeamService_GetTeam,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetTeamResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.getTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetTeam',
      request,
      metadata || {},
      methodInfo_TeamService_GetTeam);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetUserContentTeamsRequest,
 *   !proto.io.codedrills.proto.user.GetUserContentTeamsResponse>}
 */
const methodInfo_TeamService_GetUserContentTeams = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetUserContentTeamsResponse,
  /** @param {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetUserContentTeamsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetUserContentTeamsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetUserContentTeamsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.getUserContentTeams =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetUserContentTeams',
      request,
      metadata || {},
      methodInfo_TeamService_GetUserContentTeams,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetUserContentTeamsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.getUserContentTeams =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetUserContentTeams',
      request,
      metadata || {},
      methodInfo_TeamService_GetUserContentTeams);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest,
 *   !proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse>}
 */
const methodInfo_TeamService_GetAcceptedUserContentTeam = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse,
  /** @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.getAcceptedUserContentTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetAcceptedUserContentTeam',
      request,
      metadata || {},
      methodInfo_TeamService_GetAcceptedUserContentTeam,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.getAcceptedUserContentTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetAcceptedUserContentTeam',
      request,
      metadata || {},
      methodInfo_TeamService_GetAcceptedUserContentTeam);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.CreateTeamRequest,
 *   !proto.io.codedrills.proto.user.CreateTeamResponse>}
 */
const methodInfo_TeamService_CreateTeam = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.CreateTeamResponse,
  /** @param {!proto.io.codedrills.proto.user.CreateTeamRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.CreateTeamResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.CreateTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.CreateTeamResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.CreateTeamResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.createTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/CreateTeam',
      request,
      metadata || {},
      methodInfo_TeamService_CreateTeam,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.CreateTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.CreateTeamResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.createTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/CreateTeam',
      request,
      metadata || {},
      methodInfo_TeamService_CreateTeam);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateTeamInviteRequest,
 *   !proto.io.codedrills.proto.user.UpdateTeamInviteResponse>}
 */
const methodInfo_TeamService_UpdateTeamInvite = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateTeamInviteResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateTeamInviteResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateTeamInviteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateTeamInviteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.updateTeamInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/UpdateTeamInvite',
      request,
      metadata || {},
      methodInfo_TeamService_UpdateTeamInvite,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateTeamInviteResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.updateTeamInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/UpdateTeamInvite',
      request,
      metadata || {},
      methodInfo_TeamService_UpdateTeamInvite);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.DeleteTeamRequest,
 *   !proto.io.codedrills.proto.user.DeleteTeamResponse>}
 */
const methodInfo_TeamService_DeleteTeam = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.DeleteTeamResponse,
  /** @param {!proto.io.codedrills.proto.user.DeleteTeamRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.DeleteTeamResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.DeleteTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.DeleteTeamResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.DeleteTeamResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.deleteTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/DeleteTeam',
      request,
      metadata || {},
      methodInfo_TeamService_DeleteTeam,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.DeleteTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.DeleteTeamResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.deleteTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/DeleteTeam',
      request,
      metadata || {},
      methodInfo_TeamService_DeleteTeam);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetTeamsRequest,
 *   !proto.io.codedrills.proto.user.GetTeamsResponse>}
 */
const methodInfo_TeamService_GetTeams = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetTeamsResponse,
  /** @param {!proto.io.codedrills.proto.user.GetTeamsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetTeamsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetTeamsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetTeamsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetTeamsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.getTeams =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetTeams',
      request,
      metadata || {},
      methodInfo_TeamService_GetTeams,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetTeamsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetTeamsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.getTeams =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetTeams',
      request,
      metadata || {},
      methodInfo_TeamService_GetTeams);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest,
 *   !proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse>}
 */
const methodInfo_TeamService_IsAcceptedMemberInContest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse,
  /** @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.isAcceptedMemberInContest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/IsAcceptedMemberInContest',
      request,
      metadata || {},
      methodInfo_TeamService_IsAcceptedMemberInContest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.isAcceptedMemberInContest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/IsAcceptedMemberInContest',
      request,
      metadata || {},
      methodInfo_TeamService_IsAcceptedMemberInContest);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetUserTeamMappingRequest,
 *   !proto.io.codedrills.proto.user.GetUserTeamMappingResponse>}
 */
const methodInfo_TeamService_GetUserTeamMapping = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetUserTeamMappingResponse,
  /** @param {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetUserTeamMappingResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetUserTeamMappingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetUserTeamMappingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.getUserTeamMapping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetUserTeamMapping',
      request,
      metadata || {},
      methodInfo_TeamService_GetUserTeamMapping,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetUserTeamMappingResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.getUserTeamMapping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetUserTeamMapping',
      request,
      metadata || {},
      methodInfo_TeamService_GetUserTeamMapping);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetTeamAdminRequest,
 *   !proto.io.codedrills.proto.user.GetTeamAdminResponse>}
 */
const methodInfo_TeamService_GetTeamAdmin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetTeamAdminResponse,
  /** @param {!proto.io.codedrills.proto.user.GetTeamAdminRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetTeamAdminResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetTeamAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetTeamAdminResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetTeamAdminResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.getTeamAdmin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetTeamAdmin',
      request,
      metadata || {},
      methodInfo_TeamService_GetTeamAdmin,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetTeamAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetTeamAdminResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.getTeamAdmin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/GetTeamAdmin',
      request,
      metadata || {},
      methodInfo_TeamService_GetTeamAdmin);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.DeleteTeamAdminRequest,
 *   !proto.io.codedrills.proto.user.DeleteTeamAdminResponse>}
 */
const methodInfo_TeamService_DeleteTeamAdmin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.DeleteTeamAdminResponse,
  /** @param {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.DeleteTeamAdminResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.DeleteTeamAdminResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.DeleteTeamAdminResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.deleteTeamAdmin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/DeleteTeamAdmin',
      request,
      metadata || {},
      methodInfo_TeamService_DeleteTeamAdmin,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.DeleteTeamAdminResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.deleteTeamAdmin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/DeleteTeamAdmin',
      request,
      metadata || {},
      methodInfo_TeamService_DeleteTeamAdmin);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.ImportTeamsToContestRequest,
 *   !proto.io.codedrills.proto.user.ImportTeamsToContestResponse>}
 */
const methodInfo_TeamService_ImportTeamsToContest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.ImportTeamsToContestResponse,
  /** @param {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.ImportTeamsToContestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.ImportTeamsToContestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.ImportTeamsToContestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.TeamServiceClient.prototype.importTeamsToContest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/ImportTeamsToContest',
      request,
      metadata || {},
      methodInfo_TeamService_ImportTeamsToContest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.ImportTeamsToContestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.TeamServicePromiseClient.prototype.importTeamsToContest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.TeamService/ImportTeamsToContest',
      request,
      metadata || {},
      methodInfo_TeamService_ImportTeamsToContest);
};


module.exports = proto.io.codedrills.proto.user;

